import { render, staticRenderFns } from "./ModalEditIssue.vue?vue&type=template&id=db5de9bc&"
import script from "./ModalEditIssue.vue?vue&type=script&lang=js&"
export * from "./ModalEditIssue.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditIssue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports